module.exports = __webpack_public_path__ + "img/team-name-1.3b009ffe.png";